import React from "react";
import { firebase, getJobData, getTeacherData } from "~/src/api";
import {
  AppWithAuthentication, Head, Layout, Container,
} from "~/src/components/global";
import { TeacherPitchHero, TeacherDetailBody, TeacherGallery } from "~/src/components/teachers";
import Error from "~/src/pages/_error.js";

function JobPitch(props) {
  const { teacher, job, user } = props;

  if (!job || !teacher) {
    return <Error />;
  }

  let addressTo = "there";
  if (job.studio) {
    addressTo = job.studio.name;
  } else if (job.teacher) {
    addressTo = job.teacher.firstname;
  } else if (job.source && job.source.name) {
    addressTo = job.source.name;
  }

  return (
    <AppWithAuthentication>
      <Layout noHeader size="md">
        <Head
          title={`Application for ${job.name} by ${teacher.firstname} ${teacher.lastname}`}
          image={teacher.photo}
          description={`Hi ${addressTo}! I’m ${teacher.firstname} ${teacher.lastname}, and I’m thrilled to apply for your ${job.name} job.`}
        />

        <TeacherPitchHero addressTo={addressTo} job={job} teacher={teacher} user={user} />

        <TeacherGallery teacher={teacher} />

        <Container size="sm" disableMargins disableGutters>
          <TeacherDetailBody teacher={teacher} />
        </Container>
      </Layout>
    </AppWithAuthentication>
  );
}

JobPitch.getInitialProps = async function ({ query }) {
  const job = await firebase.job(query.job).get();
  const teacher = await firebase.teachers().where("username", "==", query.teacher).get();

  if (teacher.docs && teacher.docs.length) {
    const user = await firebase.user(teacher.docs[0].id).get();
    return {
      job: await getJobData({ job }),
      teacher: await getTeacherData({
        teacher: teacher.docs[0],
        withExperiences: true,
        withQualifications: true,
      }),
      user: await user.data(),
    };
  }
  return {};
};

export default JobPitch;
